export interface Vehicle {
  id: string;
  name: string;
  type: 'Scooter' | 'Motor Bike' | 'Car' | 'Tuk Tuk' | 'Bicycle';
  cc?: string;
  price: number;
  image: string;
  active: boolean;
  features: {
    fullInsurance: boolean;
    helmets?: string;
    firstAidKit: boolean;
    transmission: 'Auto' | 'Manual';
    roadAssistance: boolean;
    mileage: string;
  };
}

export const vehicles: Vehicle[] = [
  {
    id: 'honda-dio',
    name: 'Honda Dio',
    type: 'Scooter',
    cc: '110',
    price: 8,
    image: '/vehicles/honda-dio.png',
    active: true,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-vesel',
    name: 'Honda Vesel',
    type: 'Car',
    price: 50,
    image: '/vehicles/honda-vesel.png',
    active: false,
    features: {
      fullInsurance: true,
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'aprilia-scooter',
    name: 'Aprilia Scooter',
    type: 'Scooter',
    cc: '150',
    price: 10,
    image: '/vehicles/aprilia-scooter.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-shine',
    name: 'Honda Shine',
    type: 'Motor Bike',
    cc: '125',
    price: 8,
    image: '/vehicles/honda-shine.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-adv',
    name: 'Honda ADV',
    type: 'Motor Bike',
    cc: '160',
    price: 25,
    image: '/vehicles/honda-adv.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-navi',
    name: 'Honda Navi',
    type: 'Motor Bike',
    cc: '110',
    price: 8,
    image: '/vehicles/honda-navi.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'tvs-ntorq',
    name: 'TVS NTORQ',
    type: 'Motor Bike',
    cc: '125',
    price: 10,
    image: '/vehicles/tvs-ntorq.png',
    active: true,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'vmoto-electric',
    name: 'VMOTO Electric',
    type: 'Scooter',
    price: 15,
    image: '/vehicles/vmoto-electric.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: '150 KM per charge',
    },
  },
  {
    id: 'hero-xpulse',
    name: 'Hero XPulse',
    type: 'Motor Bike',
    cc: '200',
    price: 18,
    image: '/vehicles/hero-xpulse.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-hornet',
    name: 'Honda Hornet',
    type: 'Motor Bike',
    cc: '160',
    price: 15,
    image: '/vehicles/honda-hornet.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-xr',
    name: 'Honda XR',
    type: 'Motor Bike',
    cc: '250',
    price: 30,
    image: '/vehicles/honda-xr.jpg',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'honda-baja-xr',
    name: 'Honda Baja XR',
    type: 'Motor Bike',
    cc: '250',
    price: 32,
    image: '/vehicles/honda-baja-xr.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'suzuki-burgman',
    name: 'Suzuki Burgman',
    type: 'Scooter',
    cc: '125',
    price: 12,
    image: '/vehicles/suzuki-burgman.png',
    active: true,
    features: {
      fullInsurance: true,
      helmets: '1 or 2',
      firstAidKit: true,
      transmission: 'Auto',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'tuk-tuk',
    name: 'Tuk Tuk',
    type: 'Tuk Tuk',
    cc: '250',
    price: 14,
    image: '/vehicles/tuk-tuk.png',
    active: true,
    features: {
      fullInsurance: false,
      firstAidKit: true,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'mountain-cycle',
    name: 'Mountain Cycle',
    type: 'Bicycle',
    price: 3,
    image: '/vehicles/mountain-cycle.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: 'Yes',
      firstAidKit: false,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
  {
    id: 'ladies-cycle',
    name: 'Ladies Cycle',
    type: 'Bicycle',
    price: 3,
    image: '/vehicles/ladies-cycle.png',
    active: false,
    features: {
      fullInsurance: true,
      helmets: 'Yes',
      firstAidKit: false,
      transmission: 'Manual',
      roadAssistance: true,
      mileage: 'Unlimited',
    },
  },
];

// Helper to get only active vehicles
export const activeVehicles = vehicles.filter(v => v.active);

// Get vehicle types that have active vehicles
export const activeVehicleTypes = Array.from(new Set(activeVehicles.map(v => v.type)));

export const locations = [
  { value: 'negombo-hq', label: 'Ceylon Bike Rent, Negombo', price: 0 },
  { value: 'negombo', label: 'Negombo', price: 0 },
  { value: 'mirissa', label: 'Mirissa', price: 40 },
  { value: 'weligama', label: 'Weligama', price: 40 },
  { value: 'ella', label: 'Ella', price: 50 },
  { value: 'hikkaduwa', label: 'Hikkaduwa', price: 40 },
  { value: 'galle', label: 'Galle', price: 40 },
  { value: 'unawatuna', label: 'Unawatuna', price: 40 },
  { value: 'kandy', label: 'Kandy', price: 40 },
  { value: 'arugam-bay', label: 'Arugam Bay', price: 60 },
  { value: 'sigiriya', label: 'Sigiriya', price: 50 },
  { value: 'dambulla', label: 'Dambulla', price: 50 },
  { value: 'trincomalee', label: 'Trincomalee', price: 60 },
  { value: 'jaffna', label: 'Jaffna', price: 80 },
  { value: 'nuwara-eliya', label: 'Nuwara Eliya', price: 50 },
];
